import React, { useState } from "react";
import { Localized, useLocalization } from "@fluent/react";
import { AccountNumberTextInput, ContextForm, Dialog } from "cerulean";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type AccountNumberFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const AccountNumberField = ({
  revalidateErrorsOnBlur = false
}: AccountNumberFieldProps) => {
  const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
  const { l10n } = useLocalization();
  const field = "primary_account_number";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <div className="account-number-field-wrapper">
      <ContextForm.Field required key={field}>
        <AccountNumberTextInput
          field={field}
          label={l10n.getString("labelAccountNumber", null, "Account number")}
          onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
        />
        <button
          onClick={(event) => {
            event.preventDefault();
            setIsInfoDialogOpen(true);
          }}
          className="account-number-field-info narmi-icon-info"
          type="button"
          aria-label="Account number info"
        />
        <Dialog
          title="Account number"
          isOpen={isInfoDialogOpen}
          onUserDismiss={() => {
            setIsInfoDialogOpen(false);
          }}
        >
          <div>
            <p>
              <Localized id="account-number-field-info-1">
                Enter only the digits preceding punctuation or letters. For
                example, if your account number is 998877=90 or 998877 S90,
                enter 998877.
              </Localized>
            </p>
            <p>
              <Localized id="account-number-field-info-2">
                Printed checks may have extra digits following the account
                number. For example, if your account number on a check is
                998877913, enter 998877.
              </Localized>
            </p>
          </div>
        </Dialog>
      </ContextForm.Field>
    </div>
  );
};

export default AccountNumberField;
